import React from 'react';

export default class ListFilterListEntry extends React.Component {
  render() {
    const { isChecked, label } = this.props;

    return (
      <>
        <span className="top-left m-t-5">
          {isChecked ? (
            <i className="fa-fw fas fa-check-square text-primary" />
          ) : (
            <i className="fa-fw fas fa-square text-master-lighter" />
          )}
        </span>
        <span className="m-l-25 block">{label}</span>
      </>
    );
  }
}
